import { useGetEventCreationDataQuery } from '@graphql/generated';
import { useEventFeatureFlags } from '@shared/hooks/useEventFeatureFlags/useEventFeatureFlags';
import { useEventTypeConfig } from '@shared/utils/eventType';

export const useIsDashboardContentV3Enabled = ({ eventHandle }: { eventHandle: string }) => {
  const { config } = useEventTypeConfig();
  const { loading, data } = useGetEventCreationDataQuery({
    variables: {
      eventHandle
    },
    batchMode: 'fast'
  });
  const { isEventFeatureFlagEnabled, loadingEventFeatureFlags } = useEventFeatureFlags({
    eventHandle
  });

  const isEnabled = !!(isEventFeatureFlagEnabled('useDashboardV3') && config?.adminDashboardV3);

  return {
    loading: loading || loadingEventFeatureFlags,
    isEnabled,
    dataV3: data
  };
};
